export const UPDATE_FRACTURE_STATE = "UPDATE_FRACTURE_STATE"
export const UPDATE_FRACTURE_LIST_ITEM = "UPDATE_FRACTURE_LIST_ITEM"


// WEBPACK FOOTER //
// ./src/data/redux/fracture_details/actiontypes.js